module.exports = __webpack_public_path__ + "static/media/III_TuNa_Praia_-_1_de_abril_-_Cópia.793a2714.jpg";